import { createRootRoute, createRoute, createRouter } from "@tanstack/react-router";
import { z } from "zod";
import { Raiz } from "./paginas/Raiz";
import { Pipeline } from "./paginas/Pipeline";
import { Cuentas } from "./paginas/Cuentas";
import { AltaCuenta } from "./paginas/AltaCuenta";
import { Cuenta } from "./paginas/Cuenta";
import { Oportunidad } from "./paginas/Oportunidad";
import { Cotizaciones } from "./paginas/Cotizaciones";
import { Cotizacion } from "./paginas/Cotizacion";
import { Propuestas } from "./paginas/Propuestas";
import { Propuesta } from "./paginas/Propuesta";
import { Tablero } from "./paginas/Tablero";

const raiz = createRootRoute({ component: Raiz });
const pipeline = createRoute({
  getParentRoute: () => raiz,
  path: "/",
  component: Pipeline,
  validateSearch: z.object({ mias: z.boolean().optional(), q: z.string().optional() }),
});
const cuentas = createRoute({ getParentRoute: () => raiz, path: "/cuentas", component: Cuentas, validateSearch: z.object({ q: z.string().optional() }) });
const altaCuenta = createRoute({ getParentRoute: () => raiz, path: "/cuentas/nueva", component: AltaCuenta });
const cuenta = createRoute({ getParentRoute: () => raiz, path: "/cuentas/$id", component: Cuenta });
const oportunidad = createRoute({ getParentRoute: () => raiz, path: "/oportunidades/$id", component: Oportunidad });
const cotizaciones = createRoute({ getParentRoute: () => raiz, path: "/cotizaciones", component: Cotizaciones });
const nuevaCotizacion = createRoute({
  getParentRoute: () => raiz,
  path: "/cotizaciones/nueva",
  component: Cotizacion,
  validateSearch: z.object({ cuenta: z.string().optional(), oportunidad: z.string().optional() }),
});
const cotizacion = createRoute({ getParentRoute: () => raiz, path: "/cotizaciones/$id", component: Cotizacion });
const propuestas = createRoute({ getParentRoute: () => raiz, path: "/propuestas", component: Propuestas });
const propuesta = createRoute({ getParentRoute: () => raiz, path: "/propuestas/$id", component: Propuesta });
const tablero = createRoute({
  getParentRoute: () => raiz,
  path: "/tablero",
  component: Tablero,
  validateSearch: z.object({ mes: z.string().optional(), ejecutivo: z.string().optional() }),
});

export const router = createRouter({
  routeTree: raiz.addChildren([pipeline, cuentas, altaCuenta, cuenta, oportunidad, cotizaciones, nuevaCotizacion, cotizacion, propuestas, propuesta, tablero]),
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
